var _templateObject = _taggedTemplateLiteralLoose(['\n  max-width: 400px;\n'], ['\n  max-width: 400px;\n']);

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React, { Fragment, useState, useEffect } from 'react';
import styled from 'styled-components';
import { isNil, isEmpty } from 'ramda';
import InputText from '../InputText';
import InputSelect from '../InputSelect';
import ButtonGroup from '../ButtonGroup';
import Hint from '../Hint';
import Button from '../Button';
import Field from '../Form/Field';
import { findErrors } from './validators';
import nl2br from 'nl2br';
import QQFormWrapper from './qq_formwrapper';
import QQSection from './qq_section';
import QQRow from './qq_row';
import QQText from './qq_text';
import QQIntro from './qq_intro';
import { toCustomParamStr, toCustomURLString, toBrokerURLString, trackEvent } from './common';
var Industries = styled.div(_templateObject);
var options_provinces = [{
  value: 'National - employees are spread across SA',
  label: 'National'
}, {
  value: 'Eastern Cape',
  label: 'Eastern Cape'
}, {
  value: 'Free State',
  label: 'Free State'
}, {
  value: 'Gauteng',
  label: 'Gauteng'
}, {
  value: 'KwaZulu-Natal',
  label: 'KwaZulu-Natal'
}, {
  value: 'Limpopo',
  label: 'Limpopo'
}, {
  value: 'Mpumalanga',
  label: 'Mpumalanga'
}, {
  value: 'North West',
  label: 'North West'
}, {
  value: 'Northern Cape',
  label: 'Northern Cape'
}, {
  value: 'Western Cape',
  label: 'Western Cape'
}];
var options_genders = [{
  label: 'male',
  value: 'Mostly male'
}, {
  label: 'female',
  value: 'Mostly female'
}, {
  label: 'evenly split',
  value: 'Even split'
}];
var options_industry_array = ['Accommodation, food, recreation', 'Administration, support', 'Agriculture', 'Aviation, fishing, commercial diving', 'Construction (heavy)', 'Construction (light), manufacturing', 'Education', 'Financial services, professional, scientific', 'IT, communications', 'Medical (emergency), health, social work', 'Medical (other)', 'Mining, explosives, oil & gas', 'Performance arts, pro sports', 'Real estate', 'Rescue services', 'Retail trade, wholesale trade', 'Security services', 'Transport, logistics', 'Utilities, municipal services'].sort();
options_industry_array.push('Other');
var options_industry = options_industry_array.map(function (v) {
  return {
    label: v,
    value: v
  };
});

var QuickQuoteGroup = function QuickQuoteGroup(props) {
  var GROUP_URL = props.group_url || 'https://app.simply.co.za/group-start';
  var SENDER_REFERENCE = props.sender_reference || 'prefix';
  var PHONE_NUMBER_REQUIRED = props.phoneNumberRequired || false;
  var brokerCode = props.brokerCode;
  var customParameters = props.customParameters;
  var customParamStr = toCustomParamStr(customParameters);

  var _useState = useState(false),
      valid = _useState[0],
      setValid = _useState[1];

  var _useState2 = useState(),
      numEmployees = _useState2[0],
      setNumEmployees = _useState2[1];

  var _useState3 = useState(),
      gender = _useState3[0],
      setGender = _useState3[1];

  var _useState4 = useState(),
      province = _useState4[0],
      setProvince = _useState4[1];

  var _useState5 = useState(),
      age = _useState5[0],
      setAge = _useState5[1];

  var _useState6 = useState(),
      salary = _useState6[0],
      setSalary = _useState6[1];

  var _useState7 = useState(),
      industry = _useState7[0],
      setIndustry = _useState7[1];

  var _useState8 = useState(),
      phonenumber = _useState8[0],
      setPhoneNumber = _useState8[1];

  useEffect(function () {
    if (numEmployees && gender && province && age && salary && industry) {
      if (salary > 1 && age >= 18 && age <= 64 && numEmployees >= 1) {
        if (PHONE_NUMBER_REQUIRED) {
          if (!isNil(phonenumber) && !isEmpty(phonenumber) && phonenumber.length >= 10) {
            setValid(true);
          } else {
            setValid(false);
          }
        } else {
          setValid(true);
        }
      } else {
        setValid(false);
      }
    } else {
      setValid(false);
    }
  });

  function submitForm() {
    var encodedProvince = encodeURIComponent(province);
    var encodedGender = encodeURIComponent(gender);
    var encodedIndustry = encodeURIComponent(industry);
    var encodedPhoneNumber = encodeURIComponent(phonenumber);
    var phoneNumberString = !isNil(phonenumber) && !isEmpty(phonenumber) ? '&contact-cellphone-number=' + encodedPhoneNumber : '';
    var brokerURLString = toBrokerURLString(brokerCode);
    var customURLString = toCustomURLString(customParamStr);
    var url = GROUP_URL + '/prefilled-quote?total-eligible-employees-compulsory=' + numEmployees + phoneNumberString + '&gender-distribution=' + encodedGender + '&average-age=' + age + '&average-income=' + salary + '&special-industry-list=' + encodedIndustry + '&province=' + encodedProvince + '&package-id=sim-compulsory&sender-reference=' + SENDER_REFERENCE + brokerURLString + customURLString;
    trackEvent('GroupRequestQuote');
    window.location = url;
  }

  var fields = {
    numEmployees: numEmployees,
    gender: gender,
    province: province,
    age: age,
    salary: salary,
    industry: industry
  };
  var intro = props.intro,
      withShadow = props.withShadow;
  return React.createElement(QQFormWrapper, {
    withShadow: withShadow
  }, intro && React.createElement(QQIntro, null, intro), React.createElement(QQSection, null, React.createElement(QQRow, {
    className: 'row'
  }, React.createElement(QQText, null, "I\u2019d like to cover", ' ', React.createElement(InputText, {
    display: 'inline',
    size: 'small',
    placeholder: '30',
    width: '65px',
    type: 'number',
    onChange: function onChange(e) {
      return setNumEmployees(e.target.value);
    }
  }), ' ', 'employees')), React.createElement(QQRow, {
    className: 'column'
  }, React.createElement(QQText, null, 'who are mostly', ' ', React.createElement(ButtonGroup, {
    inline: true,
    setSelectedButton: setGender,
    minheight: '0px',
    selected: gender,
    buttons: options_genders,
    size: 'small'
  }))), React.createElement(QQRow, {
    withButtonGroup: true
  }, React.createElement(QQText, null, 'and largely based in', ' ', React.createElement(InputSelect, {
    placeholder: 'please select',
    width: '180px',
    display: 'inline-block',
    size: 'small',
    minheight: '0px',
    options: options_provinces,
    onChange: function onChange(val) {
      return setProvince(val.value);
    },
    onSelect: function onSelect(val) {
      return setProvince(val.value);
    }
  })))), React.createElement(QQSection, null, React.createElement(QQRow, null, React.createElement(QQText, null, 'On average they are', ' ', React.createElement(InputText, {
    min: '18',
    max: '64',
    display: 'inline',
    minheight: '0px',
    size: 'small',
    placeholder: '30',
    width: '55px',
    type: 'number',
    onChange: function onChange(e) {
      return setAge(e.target.value);
    }
  }), ' ', 'years old')), React.createElement(QQRow, {
    withButtonGroup: true
  }, React.createElement(QQText, null, 'and earn R', React.createElement(InputText, {
    display: 'inline',
    minheight: '0px',
    size: 'small',
    placeholder: '5000',
    width: '100px',
    type: 'number',
    onChange: function onChange(e) {
      return setSalary(e.target.value);
    }
  }), ' ', 'per month before tax'))), React.createElement(QQSection, null, React.createElement(QQRow, null, React.createElement(QQText, null, 'My organisation is primarily in', ' ', React.createElement(InputSelect, {
    placeholder: 'please select',
    maxWidth: '350px',
    width: '100%',
    display: 'inline-block',
    size: 'small',
    minheight: '0px',
    options: options_industry,
    onChange: function onChange(val) {
      return setIndustry(val.value);
    },
    onSelect: function onSelect(val) {
      return setIndustry(val.value);
    }
  })))), React.createElement(QQSection, null, React.createElement(QQRow, null, React.createElement(QQText, null, 'You may call me on', ' ', React.createElement(InputText, {
    display: 'inline',
    minheight: '0px',
    autocomplete: 'tel',
    size: 'small',
    placeholder: '',
    width: '160px',
    type: 'tel',
    onChange: function onChange(e) {
      return setPhoneNumber(e.target.value);
    }
  }))), React.createElement(QQRow, null, React.createElement(QQText, null, React.createElement(Hint, null, "We won\u2019t share your information with anyone")))), findErrors(valid, fields, 'group') && React.createElement(QQSection, {
    errors: true
  }, React.createElement(QQRow, null, React.createElement('span', {
    dangerouslySetInnerHTML: {
      __html: nl2br(findErrors(valid, fields, 'group'))
    }
  }))), React.createElement(QQSection, null, React.createElement(QQRow, null, React.createElement(Field, null, React.createElement(Button, {
    disabled: !valid,
    colour: 'primary',
    onClick: function onClick() {
      return submitForm();
    }
  }, 'See my estimate')))));
};

export default QuickQuoteGroup;